import { Guid } from "./Guid";

export class Fee {
  public constructor() {
    this.FeeName = "";
    this.Description = "";
    this.Qty = 0;
    this.UnitPrice = 0.00;
    this.RowPointer = Guid.newGuid();
    this.FeeLine = 1;
  }

  public RowPointer: string;
  public FeeLine: number;
  public FeeName: string;
  public Description: string;
  public Qty: number;
  public UnitPrice: number;
}
